import { Box, Typography } from "@mui/material";

import type { MessageRow } from "../../lib/api/messages";
import { formatMessageDateTime } from "../../lib/presentation";
import MessageAttachmentList from "./MessageAttachmentList";

export default function MessageBubble({
    message,
    currentUserId,
}: {
    message: MessageRow;
    currentUserId: number | null;
}) {
    const isMine = currentUserId === message.senderUserId;
    const attachments = message.attachments ?? [];

    return (
        <Box
            sx={{
                alignSelf: isMine ? "flex-end" : "flex-start",
                maxWidth: "82%",
                px: 1.5,
                py: 1,
                borderRadius: 2,
                bgcolor: isMine ? "primary.main" : "action.hover",
                color: isMine ? "primary.contrastText" : "text.primary",
            }}
        >
            {!isMine ? (
                <Typography variant="caption" sx={{ display: "block", opacity: 0.8 }}>
                    {message.senderName}
                </Typography>
            ) : null}
            {message.body ? (
                <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                    {message.body}
                </Typography>
            ) : null}
            <MessageAttachmentList attachments={attachments} inverted={isMine} />
            <Typography variant="caption" sx={{ display: "block", opacity: 0.75, mt: 0.5 }}>
                {formatMessageDateTime(message.createdAt)}
            </Typography>
        </Box>
    );
}
